import * as React from "react";

import { Field } from "@progress/kendo-react-form";

import { FormMultiSelect } from "./form-components";

import { MultiSelectChangeEvent } from "@progress/kendo-react-dropdowns";
import PowerService from "../services/PowerServices";
import { sampleProductDescription, sampleproductsResponce } from "../common/interfaces";
import { ProductDetailsProps } from "../interface/ProductDetailsProps";

export const ProductDetails = ({showLoader}: ProductDetailsProps) => {
  const [value, setValue] = React.useState<string[]>([]);
  const onChange = (event: MultiSelectChangeEvent) => {
    setValue([...event.value]);
  };
  const [sampleProducts, setSampleProducts] = React.useState({} as any);

  React.useEffect(() => {
    const fetchData = async () => {
      showLoader(true);
      let result = await PowerService.getSampleProducts() as sampleproductsResponce;
      showLoader(false);
      const products = result?.products.reduce((productsSoFar:any, { Title, SKU, Name }) => {
        if (!productsSoFar[Title]) productsSoFar[Title] = [];
        productsSoFar[Title].push({SKU, Name});
        return productsSoFar;
      }, {});
      setSampleProducts(products);
    };

    fetchData();
  }, []);

  return (
    <div>      
      {Object.keys(sampleProducts).map(
        (key, i) => {
          let prdTitles = sampleProducts[key];
          const prdTitles1 = prdTitles.map((item: sampleProductDescription) => {
            return `${item.SKU+' - '+item.Name}`;
          });
          console.log(prdTitles1);
          return <Field
            key={key}
            id={key.replace(/\s/g, "")}
            name={key}
            label={key}
            component={FormMultiSelect}
            data={prdTitles1}
            onChange={onChange}
          />
        }
      )}      
    </div>
  );
};
